import { useCurrentStateAndParams } from "@uirouter/react";
import { connect } from "react-redux";

import SegmentsAnalysisAdvancedEmptyWrapper from "app/pages/segments/analysis/SegmentsAnalysisAdvancedEmpty";
import { SegmentsGeoContainer } from "app/pages/segments/geography/SegmentsGeoContainer";
import type { ICustomSegmentAccount, ICustomSegmentsGroup } from "app/services/segments/segmentsApiService";

export interface ISegmentsGeographyContainer {
    params: any;
    organizationSegments: ICustomSegmentAccount[];
    groups: ICustomSegmentsGroup[];
}

export interface ISegmentsGeographyData {
    [countryCode: string]: ISegmentsGeoEngagementVerticals;
}

interface ISegmentsGeoData {
    [Granularity: string]: {
        Average: number;
        Confidence: number;
    };
}

interface ISegmentsGeoEngagementVerticals {
    TrafficShare: ISegmentsGeoData;
    Duration: ISegmentsGeoData;
    PagePerVisit: ISegmentsGeoData;
    BounceRate: ISegmentsGeoData;
    PageViews: ISegmentsGeoData;
}

const SegmentsGeographyContainer = (props: ISegmentsGeographyContainer) => {
    const { params } = useCurrentStateAndParams();
    const componentProps = { ...props, params };
    return (
        <SegmentsAnalysisAdvancedEmptyWrapper>
            <SegmentsGeoContainer {...componentProps} />
        </SegmentsAnalysisAdvancedEmptyWrapper>
    );
};

function mapStateToProps(store) {
    const {
        segmentsModule: { customSegmentsMeta, segmentsLoading },
    } = store;
    return {
        segments: customSegmentsMeta?.Segments,
        organizationSegments: customSegmentsMeta?.AccountSegments,
        groups: customSegmentsMeta?.SegmentGroups,
        customSegmentsMeta: customSegmentsMeta,
        isLoading: segmentsLoading,
    };
}

export default connect(mapStateToProps, undefined)(SegmentsGeographyContainer);
